$(document).ready(() => {
  if (!$('#signature-subscription-id').length) {
    return;
  }

  function signatureTimeout() {
    if (!(typeof iframe == 'object')) {
      App.cable.disconnect();
    }

    displayError();
  }

  function displayError() {
    $('#subscription-step-1-success').addClass('d-none');
    $('#subscription-step-2').addClass('d-none');
    $('#subscription-step-3').addClass('d-none');
    new bootstrap.Modal('#subscription-step-1-failure').show();
  }

  let signatureTimeoutId = setTimeout(signatureTimeout, 180000);

  App.cable.subscriptions.create(
    {
      channel: 'SignatureChannel',
      subscription_id: $('#signature-subscription-id').data('id'),
    },
    {
      received(data) {
        clearTimeout(signatureTimeoutId);

        try {
          if (data.status == 'success') {
            const yousign = new Yousign({
              signatureLink: data.signature_url,
              iframeContainerId: 'subscription-step-2',
              isSandbox: $('#subscription-step-2').data('is-sandbox'),
            });

            $('#subscription-step-2 #yousign-iframe').addClass('vh-100 w-100');

            yousign.onSuccess((_data) => {
              $('#subscription-step-2 #yousign-iframe').addClass('d-none');
              $('#loader').removeClass('d-none');
              window.scrollTo({ top: 0 });
            });

            yousign.onError((_data) => {
              displayError();
            });

            $('#contract-loaded-button').prop('disabled', false);
            $('#contract-loaded-button').removeClass('btn-description');
            $('#contract-loaded-button #contractLoading').addClass('d-none');
            $('#contract-loaded-button #contractReady').removeClass('d-none');
            $('#generating_doc_explanations').addClass('d-none');
            $('#generating_doc_ready').removeClass('d-none');
            $('#contract-loading-icon').addClass('d-none');

            $('#contract-loaded-button').on('click', (e) => {
              $('#subscription-step-2').removeClass('d-none');
              $('#subscription-step-1-success').addClass('d-none');
            });
          } else if (data.status == 'error') {
            displayError();
          } else if (data.status === 'done') {
            window.location = $('#subscription-step-2').data('redirect-url');
          } else {
            setTimeout(() => {
              displayError();
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            displayError();
          }, 5000);
        }
      },
      rejected() {
        clearTimeout(signatureTimeoutId);
        setTimeout(() => {
          displayError();
        }, 5000);
      },
    }
  );
});
